// Custom icon static resources

import { BulbOutline, ExceptionOutline, ExportOutline, FieldTimeOutline, InfoOutline, InteractionOutline, LinkOutline, MenuOutline, PartitionOutline, ProfileOutline, UserAddOutline, UserOutline, UserSwitchOutline
} from '@ant-design/icons-angular/icons';

export const ICONS = [InfoOutline, BulbOutline, ProfileOutline, ExceptionOutline, LinkOutline, ExportOutline, FieldTimeOutline, MenuOutline, UserSwitchOutline, UserAddOutline, InteractionOutline, UserOutline, PartitionOutline,
];
